import "./InboxPage.styles.scss";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { TopNav, PageTitle, Tabs } from "components";
import useInboxPageTabs from "./useInboxPageTabs";
import { useFetchSubmissions } from "utils/hooks";

const InboxPage = () => {
  const dataRef = useRef(false);
  const { t } = useTranslation(["common"]);
  const title = t("page_titles.inbox_title");
  const { tabItems, activeTab, handleTabChange } = useInboxPageTabs();
  const { fetchPracticeSubmissions } = useFetchSubmissions();

  useEffect(() => {
    if (dataRef.current) return;
    fetchPracticeSubmissions();
    dataRef.current = true;
  }, [fetchPracticeSubmissions]);

  return (
    <>
      <TopNav
        topL={<PageTitle text={title} />}
        botL={
          <Tabs
            responsive
            items={tabItems}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
            size={"main"}
            extraClass={"main-tabs"}
          />
        }
      />
      <div>{activeTab?.mainComponent}</div>
    </>
  );
};

export default InboxPage;
